import Button from "components/ui/Button/Button";
import { useEntity } from 'hooks/useEntity'
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import ImageHero from "features/bulletins/assets/images/hero-prikbord.png?v2";
import { ReactComponent as IconCreatePost } from "assets/images/icons/pencil-square.svg";
import { ReactComponent as IconMegaphone } from "assets/images/icons/megaphone.svg";
import ViewContextProvider from "features/view/context/ViewContext";
import { useDialog } from "context/DialogContext";
import { useHistory } from "react-router-dom";
import { useLocationAwareSortOptions, defaultSortOptions } from "hooks/useLocationAwareSortOptions";
import GroupCreateUpdate from "features/groups/components/GroupCreateUpdate";
import ViewGroups from "features/groups/components/ViewGroups";

function Groups({ title }) {
  const { showDialog } = useDialog();
  const history = useHistory();
  const { entity, error } = useEntity('/groepen', 'page');

  let sortOptions = [...defaultSortOptions];
  sortOptions.unshift(
    {
      id: 'member_count|DESC',
      value: 'Aantal leden (aflopend)',
    }
  );
  sortOptions = useLocationAwareSortOptions(sortOptions);

  useTitle(title);

  if (error) {
    return <Alert/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ ImageHero }
                 sortOptions={ sortOptions }>
        <Button variant="secondary" onClick={ () => showDialog(<GroupCreateUpdate
          onCompleted={ group => history.push(group.url) }/>) }>
          <IconCreatePost/>
          Nieuwe groep maken
        </Button>

        <Button variant="secondary" onClick={ () => history.push('/groepen/mijn-groepen') }>
          <IconMegaphone/>
          Mijn groepen
        </Button>
      </TopBanner>
      <div className="wrapper--fluid grid">
        <div className="content content--background">
          <div className="grid">
            <ViewContextProvider name="group">
              <ViewGroups/>
            </ViewContextProvider>
          </div>
        </div>
      </div>
    </>
  )
}

export default Groups;
